import { render, staticRenderFns } from "./VpayAccountOrderDetail.vue?vue&type=template&id=a575339e&scoped=true"
import script from "./VpayAccountOrderDetail.vue?vue&type=script&lang=js"
export * from "./VpayAccountOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./VpayAccountOrderDetail.vue?vue&type=style&index=0&id=a575339e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a575339e",
  null
  
)

export default component.exports